import { allTrackers } from "app/services/track/track";

export enum EWidgetState {
    INITIAL,
    NO_DATA,
}

export abstract class NoDataEvent<T extends readonly string[]> {
    protected widgets: Record<T[number], EWidgetState>;

    private trackNoData() {
        allTrackers.trackEvent("N/A state", "Fetch demographics data", "There is no data in ALL widgets");
    }

    private validateNoDataAmount() {
        const widgetStates = Object.values(this.widgets);
        const noDataAmount = widgetStates.filter((state) => state === EWidgetState.NO_DATA).length;
        if (widgetStates.length === noDataAmount) {
            this.trackNoData();
        }
    }

    public reset(widget: T[number]) {
        this.widgets[widget] = EWidgetState.INITIAL;
    }

    public noData(widget: T[number]) {
        this.widgets[widget] = EWidgetState.NO_DATA;
        this.validateNoDataAmount();
    }
}
